export default function dateFilter(date) {
  if (date && date !== '') {
    return date.split(' ')[0];
  }
  return date;
}
